import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36.5 32.8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      transform: "translate(-5 -2.8)"
    }, [
      _createElementVNode("path", { d: "M25 33.267h-7.8v-23.3H25z" }),
      _createElementVNode("rect", {
        width: "31",
        height: "7.8",
        rx: "0",
        ry: "0",
        transform: "rotate(-75.001 34.34 .153)"
      }),
      _createElementVNode("rect", {
        width: "15.436",
        height: "7.8",
        rx: "0",
        ry: "0",
        transform: "rotate(-105.212 18.185 14.056)scale(.99997)"
      })
    ], -1)
  ])))
}
export default { render: render }